export default "__VITE_ASSET__d3fd7dec__"